<template>
  <m-layout-grid class="app-layout-grid--content">
    <app-layout-grid-inner-custom
      class="app-layout-grid-inner--portada__buscador-filtro  app-layout-grid-inner--height100"
    >
      <m-layout-grid-cell
        :span-phone="4"
        :span-tablet="8"
        :span-desktop="5"
        align="bottom"
      >
        <app-portada-buscador-filtro />
      </m-layout-grid-cell>
      <!-- <m-layout-grid-cell :span-phone="4" :span-tablet="8" :span="6" /> para que no slaga en movil-->
    </app-layout-grid-inner-custom>
    <app-layout-grid-inner-custom
      class="app-layout-grid-inner--portada__totales"
    >
      <m-layout-grid-cell
        :span-phone="4"
        :span-tablet="8"
        :span="12"
        align="middle"
      >
        <!-- <div>
          <span style="font-weight: bold">3257 Inmuebles localizados</span>
          en toda Andalucía
        </div> -->
        <div v-if="isInmueblesTotalCountShown">
          <span style="font-weight: bold"
            >{{ inmueblesTotalCount }} Inmuebles localizados</span
          >
          en toda Andalucía
        </div>

        <span v-if="!isInmueblesTotalCountShown" class="blinking"
          >Calculando total de inmuebles en catálogo...</span
        >
      </m-layout-grid-cell>
    </app-layout-grid-inner-custom>
    <app-layout-grid-inner-custom
      class="app-layout-grid-inner--portada__buscador-simple"
    >
      <m-layout-grid-cell :span="12" align="middle">
        <app-portada-buscador-simple />
      </m-layout-grid-cell>
    </app-layout-grid-inner-custom>
  </m-layout-grid>
</template>

<script>
export default {
  name: "portada",
  data() {
    return {
      dataResourceName: "inmuebles",
      inmueblesTotalCount: 3000,
      isInmueblesTotalCountShown: false
    };
  },
  mounted() {
    // lo quito para ver si así se aligera la carga
    this.initViewFirstTime();
  },
  methods: {
    initViewFirstTime() {
      this.updateInmueblesTotalCount();
    },
    updateInmueblesTotalCount() {
      var self = this;
      var options = {
        paginationCurrentPage: 1,
        paginationResultsPerPage: 4,
        fullTextSearch: null,
        sortFieldName: null,
        sortOrder: null,
        totalResultsNumber: null,
        filterTerms: {},
        fixedFilterTerms: {}
      };
      this.isInmueblesTotalCountShown = false;

      this.$mdApp.dataAccess
        .readList(this.dataResourceName, options)
        .then(function(response) {
          self.inmueblesTotalCount = response.headers["x-total-count"];
          self.isInmueblesTotalCountShown = true;
        });
    }
  }
};
</script>

<style lang="scss">
@import "@material/layout-grid/mdc-layout-grid.scss";

// Esto es para que el grid ocupe todo el ancho para que el color llene por completo
.app-layout-grid--content {
  margin: 0 0 0 0 !important;
  padding: 0 0 0 0 !important;
}

.app-layout-grid-inner--portada__buscador-filtro {
  background-color: none; // Para que se vea la imagen de fondo
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "tablet")) {
  .app-layout-grid-inner--portada__buscador-filtro {
    height: 655px;
  }
}

.app-layout-grid-inner--portada__totales {
  padding-top: 3em;
  padding-bottom: 3em;
  color: #607d8b;
  background-color: white;
  text-align: center;
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "tablet")) {
  .app-layout-grid-inner--portada__totales {
    font-size: 24px;
  }
}

.app-layout-grid-inner--portada__buscador-simple {
  padding-top: 3em;
  padding-bottom: 5em;
  background-color: #f7fafa;
}

// Los hacks de IE11... :(
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .app-layout-grid--content {
    padding: 0; // no sé pq mete el ie11 de las narices el padding
  }
}
</style>
